import { ref } from 'vue'

// Set true when Back is clicked so all project text fades out before navigation.
// Cleared in Index.vue onActivated.
export const projectFading = ref(false)
